export default __webpack_public_path__ + "static/media/cheatday@2x.436d203c.jpg";